export default __webpack_public_path__ + "static/media/about4.5312c92c.jpeg";